import { AxiosResponse } from "axios";
import { call, put, takeEvery } from "redux-saga/effects";
import { baseInstance } from "../../service/instance";
import { ENDPOINTS} from "../../service/api";
import { toastError, toastSuccess } from "../../shared/util/toast.message";
import { getSecurityCodeSuccess,   getSecurityCodeError, getLoginDeviceInfoSuccess, getLoginDeviceInfoError, getCodeForPasswordSuccess, getCodeForPasswordError, updatePasswordWithCodeSuccess, updatePasswordWithCodeError, signoutFromEverywhereSuccess, signoutFromEverywhereError, sessionSignoutSuccess, sessionSignoutError } from "../features/auth.slice";
import { MESSAGES } from "../../config/app";

function* getSecurityCode(action : any) {
  const { callBackSuccess, body, successMessage,callBackFailure } = action?.payload;
  try {
    const res: AxiosResponse = yield call(
      baseInstance.post,
      ENDPOINTS?.SEND_SECURITY_CODE,
      body
    );
    if (res.data.statuscode===200) {
        const ress: any = res.data.data;
        yield put(getSecurityCodeSuccess(ress));
        toastSuccess(successMessage?successMessage:MESSAGES.securityCodeSuccess);
        callBackSuccess();
    }
  } catch (err:any) {
    callBackFailure()
    toastError(err.message);
    yield put(getSecurityCodeError(err));
  }
}

function* getLoginDeviceInfo(action : any){
  // const{callBackSuccess, callBackFailure} = action?.payload;
  try {
   const res: AxiosResponse = yield call(
    baseInstance.get,
    ENDPOINTS?.LOGIN_DEVICE_INFO
   );
   if(res?.data?.statuscode===200){
    const ress: any = res.data.data;
        yield put(getLoginDeviceInfoSuccess(ress));
        //toastSuccess(successMessage?successMessage:MESSAGES.securityCodeSuccess);
        // callBackSuccess();
   }
  } catch (err:any) {
    // callBackFailure()
    toastError(err.message);
    yield put(getLoginDeviceInfoError(err));
  }
}

function* getSecurityCodeForPassword(action : any){
  const{callBackSuccess, callBackFailure} = action?.payload;
  try {
   const res: AxiosResponse = yield call(
    baseInstance.post,
    ENDPOINTS?.SET_PASSWORD_CODE
   );
   if(res?.data?.statuscode===200){
    const ress: any = res.data.data;
        yield put(getCodeForPasswordSuccess(ress));
        toastSuccess(MESSAGES.securityCodeSuccess);
        callBackSuccess(res?.data?.data?.to);
   }
  } catch (err:any) {
    callBackFailure();
    toastError(err.message);
    yield put(getCodeForPasswordError(err));
  }
}

function* updatePasswordWithCode(action : any) {
  const { callBackSuccess, body, successMessage,callBackFailure } = action?.payload;
  try {
    const res: AxiosResponse = yield call(
      baseInstance.post,
      ENDPOINTS?.SET_PASSWORD,
      body
    );
    if (res.data.statuscode===200) {
        const ress: any = res.data.data;
        yield put(updatePasswordWithCodeSuccess(ress));
        toastSuccess(successMessage?successMessage:MESSAGES.setPasswordSuccess);
        callBackSuccess();
    }
  } catch (err:any) {
    callBackFailure()
    toastError(err.message);
    yield put(updatePasswordWithCodeError(err));
  }
}

function* signoutFromEverywhere(action : any) {
  const { callBackSuccess, params } = action?.payload;
  try {
    const res: AxiosResponse = yield call(
      baseInstance.delete,
      ENDPOINTS?.SIGNOUT_EVERYWHERE,
      {params}
    );
    if (res.data.statuscode===200) {
        const ress: any = res.data.data;
        yield put(signoutFromEverywhereSuccess(ress));
        callBackSuccess();
    }
  } catch (err:any) {
    toastError(err.message);
    yield put(signoutFromEverywhereError(err));
  }
}

function* signoutFromSession(action : any) {
  const { callBackSuccess, params } = action?.payload;
  try {
    const res: AxiosResponse = yield call(
      baseInstance.delete,
      ENDPOINTS?.SIGNOUT_SESSION,
      {params}
    );
    if (res.data.statuscode===200) {
        const ress: any = res.data.data;
        yield put(sessionSignoutSuccess(ress));
        callBackSuccess();
    }
  } catch (err:any) {
    toastError(err.message);
    yield put(sessionSignoutError(err));
  }
}

function* authSaga() {
  yield takeEvery("authStateSlice/getSecurityCode",getSecurityCode);
  yield takeEvery("authStateSlice/getLoginDeviceInfo",getLoginDeviceInfo);
  yield takeEvery("authStateSlice/getCodeForPassword",getSecurityCodeForPassword);
  yield takeEvery("authStateSlice/updatePasswordWithCode",updatePasswordWithCode);
  yield takeEvery("authStateSlice/signoutFromEverywhere",signoutFromEverywhere);
  yield takeEvery("authStateSlice/sessionSignout",signoutFromSession);
}
export default authSaga;